import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Spinner: FC<IconSvgProps> = () => {
    return <span className="spinner" aria-label={'fetching data'} />;
};

export default Spinner;
